import React, { Component } from "react";
import {
  Col,
  Row,
  Nav,
  Card,
  Table,
  Form,
  Button,
  ButtonGroup,
  Breadcrumb,
  InputGroup,
  Dropdown,

} from "@themesberg/react-bootstrap";
import { FormGroup, CardHeader, Media, Input, Modal } from "reactstrap";
import Select from 'react-select';
import { faEnvelope, faPhone, faLock, faPencilAlt, faAddressCard, faUnlockAlt, faEyeSlash, faEye, faLocationArrow, faPiggyBank } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SpinDiv from "../components/SpinDiv";
import { toast } from "react-toastify";
import { addPromotion, editPromotion } from "../../services/promotionService";
import { getDesignations } from "../../services/designationService";
import AsyncSelect from "react-select/async";
import ReactDatetime from "react-datetime";
import moment from "moment"

export class EditPromotion extends Component {
  constructor(props) {
    super(props);
    this.state = {

      employees: props.employees,
      designations: props.designations,
      dated: moment().startOf('month'),
      id: props.promotion.id,
      promotion: props.promotion,
      employee_designation: {},
      employee_id: props.promotion.employee_id,
      user: JSON.parse(localStorage.getItem('user')),

    };
  }

  componentDidMount() {
    toast.configure({ hideProgressBar: true, closeButton: false });
    console.log(this.state.promotion)

  }


  getEmployeeDesignation = () => {
    const { page, rows, search, employee_id } = this.state;
    console.log(employee_id)
    this.setState({ loading: true });
    getDesignations({ page, rows, search, employee_id }).then(

      (res) => {
        this.setState({
          employee_designation: res.employee_designation,
          loading: false,
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };




  onSavePromotion = async (e) => {
    e.preventDefault();
    await toast.dismiss();
    const { description, title, designation_id, dated, employee_id } = this.state.promotion;
    const { validation } = this.state;
    await this.setState({
      validation: {
        ...validation,
        employee_id: employee_id !== '' && employee_id !== undefined,
        designation_id: designation_id !== '' && designation_id !== undefined,
        dated: dated !== '' && dated !== undefined,
        description: description !== '' && description !== undefined,
        title: title !== '' && title !== undefined,
      },
    });
    if (Object.values(this.state.validation).every(Boolean)) {
      this.savePromotion();
    } else {
      const errors = Object.keys(this.state.validation).filter((id) => {
        return !this.state.validation[id];
      });
      //await toast.configure({hideProgressBar: true, closeButton: false});
      toast.dismiss();
      toast.configure({ hideProgressBar: true, closeButton: false });

      toast(
        <div style={{ padding: "10px 20px" }}>
          <p style={{ margin: 0, fontWeight: "bold", color: "red" }}>Errors:</p>
          {errors.map((v) => (
            <p key={v} style={{ margin: 0, fontSize: 14, color: "red" }}>
              * {this.validationRules(v)}
            </p>
          ))}
        </div>
      )
    }
  };


  validationRules = (field) => {
    if (field === "employee_id") {
      return "Employee Name  is required";
    } else if (field == 'designation_id') {
      return "Designation is required"
    } else if (field == 'dated') {
      return "Date promoted is required"
    } else if (field == 'description') {
      return "Description is required"
    } else if (field == 'title') {
      return "Title is required"
    }
  };




  savePromotion = () => {
    this.setState({ saving: true });
    const { promotion, id, employee_designation } = this.state;
    var former_designation_id = employee_designation !== null ? employee_designation.designation_id : '';
    console.log();
    editPromotion({
      employee_id: promotion.employee_id,
      designation_id: promotion.designation_id,
      description: promotion.description,
      former_designation_id: former_designation_id,
      title: promotion.title,
      id: id,
      dated: promotion.dated,

    }).then(
      (res) => {
        console.log(res);
        this.setState({ loading: false, saving: false });
        this.props.saved();
        this.props.toggle();
        this.showToast("Promotion has been updated");
      },
      (err) => {

        if (err) {
          toast.dismiss();
          toast.configure({ hideProgressBar: true, closeButton: false });
          if (err) {
            this.showToastError('An error occured')
          }
          this.setState({ saving: false });
        }
        this.setState({ loading: false });
      }
    );
  };



  showToast = msg => {
    toast(<div style={{ padding: 20, color: "green" }}>{msg}</div>);
  }
  showToastError = (msg) => {
    toast(<div style={{ padding: 20, color: "red" }}>{msg}</div>);
  };

  onChange2 = (e, state) => {
    this.setState({ [state]: e });
    this.getEmployeeDesignation()
  };

  onChange = (e, state) => {
    const { promotion } = this.state

    this.setState({ promotion: { ...promotion, [state]: e } })

  }

  dateFilter = async (e, state) => {
    await this.setState({ [state]: e })
  }



  toggleEdit = () => {
    this.setState({ edit: !this.state.edit });
  };






  render() {

    const { toggle } = this.props;

    const { saving, user, edit, employee_id, promotion, employee_designation, employees, designations, loading } = this.state;
    return (
      <>
        <Modal
          className="modal-dialog modal-dialog-top"
          isOpen={promotion != null}
          toggle={() => !loading && !saving && toggle}
          style={{ maxWidth: 700 }}
        >
          {saving && <SpinDiv text={"Saving..."} />}
          {loading && <SpinDiv text={"loading..."} />}
          <div className="modal-header" style={{ padding: "1rem" }}>
            {user.admin == 1 && <div className="btn-toolbar mb-2 mb-md-0">
              <ButtonGroup>
                {promotion && (

                  <Button color={edit ? "secondary" : "success"}
                    onClick={this.toggleEdit}
                    size="sm" variant="outline-primary">
                    {edit ? "Discard Changes" : "Edit Promotion"}



                  </Button>
                )}
              </ButtonGroup>
            </div>}


            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={toggle}
            ></button>
          </div>
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="pb-0">
              <Row>
                <Col md={12} style={{ paddingTop: 15 }}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Title</Form.Label>
                    <Input
                      className="custom-control-input"
                      id="title"
                      disabled={!edit}
                      placeholder='Enter Title'
                      value={promotion.title}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "title");
                      }}
                      type="text"
                    />
                  </Form.Group>

                </Col>
              </Row>
              <Row>
                <Col md={6} >
                  <Form.Group className="mb-2">
                    <Form.Label>Employee</Form.Label>

                    <Form.Select
                      id="state"
                      required
                      disabled={!edit}
                      value={employee_id}
                      onChange={async (e) => {
                        await this.onChange2(e.target.value, "employee_id");
                      }}
                      style={{
                        marginRight: 10,
                        width: "100%",
                      }}
                    >

                      <option value="">Select Employee</option>
                      {employees.length == 0 && <option value="">loading</option>}
                      {employees.map((p, index) => (
                        <option value={p.user_id} key={p}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </Col>
                {user.admin == 1 ? <Col md={6} style={{ paddingTop: 15 }}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Former Designation</Form.Label>
                    <Input
                      className="custom-control-input"
                      disabled

                      value={(employee_id && employee_designation !== null) && employee_designation.designation_name}
                      type="text"
                    />
                  </Form.Group>

                </Col>
                  : <Col md={6} style={{ paddingTop: 15 }}>
                    <Form.Group className="mb-2">
                      <Form.Label style={{ paddingRight: 10 }}>Former Designation</Form.Label>
                      <Input
                        className="custom-control-input"
                        disabled

                        value={promotion.former_designation}
                        type="text"
                      />
                    </Form.Group>

                  </Col>
                }

                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label>Designation</Form.Label>

                    <Form.Select
                      id="state"
                      required
                      disabled={!edit}
                      value={promotion.designation_id}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "designation_id");
                      }}
                      style={{
                        marginRight: 10,
                        width: "100%",
                      }}
                    >

                      <option value="">choose Promotion </option>
                      {designations.length == 0 && <option value="">loading</option>}
                      {designations.map((p, index) => (
                        <option value={p.id} key={p}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </Col>

              </Row>

              <Row>
                <Col md="6">
                  <FormGroup className="form-date">
                    <label
                      className="form-control-label"
                      htmlFor="input-address"
                    >
                      Date Created
                    </label>
                    <ReactDatetime
                      disabled={!edit}
                      value={moment(promotion.dated).format('MMM DD, YYYY') || ''}
                      dateFormat={'MMM D, YYYY'}
                      closeOnSelect
                      onChange={e => this.onChange(e, 'dated')}
                      inputProps={{
                        required: true,
                        className: 'form-control date-width'
                      }}
                      timeFormat={false}
                    />
                  </FormGroup>
                </Col>


              </Row>

              <Row>
                <Col md={6} style={{ paddingTop: 15 }}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Description</Form.Label>
                    <Input
                      disabled={!edit}
                      className="custom-control-input"
                      id="reason"
                      placeholder='Enter Description'
                      value={promotion.description}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "description");
                      }}
                      type="textarea"
                    />
                  </Form.Group>

                </Col>

              </Row>
              <Row>

              </Row>
              {user.admin == 1 && <Row style={{ marginTop: "10px" }}>
                <Col md={12}>
                  <div>
                    <Button
                      variant="primary"
                      size="sm"
                      style={{ marginTop: "10px", float: "right" }}
                      disabled={saving}
                      onClick={this.onSavePromotion}
                    >
                      Save
                    </Button>
                    <Button
                      size="sm"
                      variant="transparent"
                      data-dismiss="modal"
                      type="button"
                      disabled={saving}
                      style={{ marginTop: "10px", float: "right" }}
                      onClick={toggle}
                    >
                      {" "}
                      Close
                    </Button>
                  </div>
                </Col>
              </Row>}


            </Card.Body>
          </Card>
        </Modal>
      </>
    );
  }
}

export default EditPromotion;
